import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 70px;
  min-height:1000px;

  @media (min-width: 992px) {
    padding-top:80px;
  }
`;

export const WhiteContainer = styled.div`
  text-align:left; 
  padding:20px 0;
  background-color:#fff;
  border-bottom:1px solid #e6e6e6;

  @media (min-width: 992px) {
    padding:30px 0;
    text-align:center; 
  }
`
export const GreyContainer = styled.div`
  text-align:left; 
  padding:20px 0;
  background-color:#efefef;
  border-bottom:1px solid #e6e6e6;

  @media (min-width: 992px) {
    padding:30px 0;
    text-align: center; 
  }
`

export const BlueContainer = styled.div`
  text-align:left; 
  padding:20px 0;
  color: #fff;
  background: #182750;;
  border-bottom:1px solid #e6e6e6;
  

  @media (min-width: 992px) {
    padding:30px 0;
    text-align:center; 
  }
`

export const SoftGreyContainer = styled.div`
  text-align:left; 
  padding:20px 0;
  background-color:#f9f9f9;
  border-bottom:1px solid #e6e6e6;

  @media (min-width: 992px) {
    padding:30px 0;
    text-align: center; 
  }
`


export default Container;
